import { z } from 'zod';

export const DONOR_KINDS = ['individual', 'organization'] as const;
export type DonorKind = (typeof DONOR_KINDS)[number];
export const donorKindSchema = z.enum(DONOR_KINDS);

/**
 * The two signals the cross-institution existence lookup will answer about, and
 * the only two `donor_link_requests.matched_signal` can hold. A tax id is
 * decisive for `findDuplicates` inside the caller's own scope but is never
 * disclosed across institutions, and a name is never decisive anywhere — see
 * docs/decisions/0024-donors-dedup-and-merge.md.
 */
export const DONOR_LINK_SIGNALS = ['email', 'phone'] as const;
export type DonorLinkSignal = (typeof DONOR_LINK_SIGNALS)[number];
export const donorLinkSignalSchema = z.enum(DONOR_LINK_SIGNALS);

export const DONOR_LINK_REQUEST_STATUSES = ['open', 'accepted', 'declined', 'expired'] as const;
export type DonorLinkRequestStatus = (typeof DONOR_LINK_REQUEST_STATUSES)[number];
export const donorLinkRequestStatusSchema = z.enum(DONOR_LINK_REQUEST_STATUSES);

/**
 * How long an unanswered link request stands before it stops granting anything.
 * Long enough for a branch that answers its inbox weekly, short enough that a
 * request nobody looked at expires rather than being accepted a year later by
 * someone with no memory of it. Deliberately not an environment variable: it
 * does not vary by environment.
 */
export const DONOR_LINK_REQUEST_TTL_DAYS = 30;

/**
 * The scopes broad enough to run the cross-institution duplicate report. It is
 * the fallback for a link request that was declined or expired, and those
 * duplicates are only cleanable from a seat that holds both sides — see
 * docs/decisions/0024-donors-dedup-and-merge.md.
 */
export const DUPLICATE_REPORT_SCOPE_LEVELS = ['zone', 'region', 'global'] as const;
